import api from '../api';

export default {
  edit(id: string, name: string): Promise<void> {
    return api.put(`accounts/${id}`, { name }).then();
  },
};
